import { render } from "./WalletBreakdownByInstrumentType.vue?vue&type=template&id=4b87b9a3&scoped=true"
import script from "./WalletBreakdownByInstrumentType.vue?vue&type=script&lang=js"
export * from "./WalletBreakdownByInstrumentType.vue?vue&type=script&lang=js"

import "./WalletBreakdownByInstrumentType.vue?vue&type=style&index=0&id=4b87b9a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b87b9a3"]])

export default __exports__